/**
 * 日期范围工具类
 */

/* 补零 */
export function padZero(n) {
  return n < 10 ? '0' + n : n;
}

/* 获取年月日 */
export function getYMD(separator = '/', t = Date.now()) {
  const date = new Date(typeof separator == 'number' ? separator : t)

  let y = date.getFullYear()
  let m = date.getMonth() + 1
  let d = date.getDate()

  // return y + s + padZero(m) + s + padZero(d)
  return [y, m, d].map(function (v) {
    return padZero(v)  // [2021, 07, 08]
  }).join(typeof separator == 'number' ? '/' : separator)
}

/* 获取时分秒 */
export function getHMS(separator = ':', t = Date.now()) {
  const date = new Date(typeof separator == 'number' ? separator : t)

  let h = date.getHours()
  let m = date.getMinutes()
  let s = date.getSeconds()

  return [h, m, s].map(function (v) {
    return padZero(v)  // [2021, 07, 08]
  }).join(typeof separator == 'number' ? ':' : separator)
}

/* 获取年月日 时分秒 */
export function getYMDHMS(s1, s2, t) {
  return getYMD(s1, t) + ' ' + getHMS(s2, t)
}


export function startTime(time) {
  const nowTimeDate = new Date(time)
  return nowTimeDate.setHours(0, 0, 0, 0)
}

export function endTime(time) {
  const nowTimeDate = new Date(time)
  return nowTimeDate.setHours(23, 59, 59, 999)
}

/***
 * 今天的开始时间
 */
export function getBeginToday() {
  return new Date(new Date(new Date().toLocaleDateString()).getTime());
}

/***
 * 当前时间
 */
export function getCurrentDate() {
  return new Date();
}


/***
 * 昨天开始时间
 */
export function getBeginYesterday() {
  return startTime(getBeginToday() - 24 * 60 * 60 * 1000);
}


/***
 * 昨天结束时间时间
 */
export function getEndYesterday() {
  return endTime(getBeginToday() - 24 * 60 * 60 * 1000);
}
/***
 * 本周的第一天时间
 */
export function getBeginWeek() {
  var currentDate = getCurrentDate();
  var week = currentDate.getDay();

  //一天的毫秒数
  var millisecond = 1000 * 60 * 60 * 24;
  //减去的天数
  var minusDay = week != 0 ? week - 1 : 6;
  //本周 周一
  var monday = new Date(currentDate.getTime() - (minusDay * millisecond));
  return startTime(monday);
}

/***
 * 本周的最后一天时间
 */
export function getEndWeek() {
  var currentDate = getCurrentDate();
  var week = currentDate.getDay();
  //一天的毫秒数
  var millisecond = 1000 * 60 * 60 * 24;
  //减去的天数
  var minusDay = week != 0 ? week - 1 : 6;
  //本周 周日
  var monday = new Date(currentDate.getTime() - (minusDay * millisecond));
  var sunday = new Date(monday.getTime() + (6 * millisecond));
  //返回
  return endTime(sunday);
}

/***
 * 上周的开始
 */
export function getBeginLastWeek() {
  var currentDate = getCurrentDate();
  var first = currentDate.getDate() - currentDate.getDay() - 6;
  var startDate = new Date(currentDate.setDate(first));
  return startTime(startDate);
}

/***
 * 上周的结束
 */
export function getEndLastWeek() {
  var currentDate = getCurrentDate();
  var first = currentDate.getDate() - currentDate.getDay() - 6;
  var last = first + 6;
  var endDate = new Date(currentDate.setDate(last));
  return endTime(endDate);
}

/***
 * 本月的第一天时间
 */
export function getBeginMonth() {
  var currentDate = getCurrentDate();
  var currentMonth = currentDate.getMonth();
  //获得当前年份4位年
  var currentYear = currentDate.getFullYear();
  //求出本月第一天
  var firstDay = new Date(currentYear, currentMonth, 1);

  return firstDay;
};

/***
 * 本月的最后一天时间
 */
export function getEndMonth() {
  //获取当前时间
  var currentDate = getCurrentDate();
  var fullYear = currentDate.getFullYear();
  var month = currentDate.getMonth() + 1; // getMonth 方法返回 0-11，代表1-12月
  var endOfMonth = new Date(fullYear, month, 0);
  return endTime(endOfMonth);
};

/***
 * 上月的第一天时间
 */
export function getBeginLastMonth() {
  //获取当前时间
  var currentDate = getCurrentDate();
  //获得当前月份0-11
  var currentMonth = currentDate.getMonth();
  //获得当前年份4位年
  var currentYear = currentDate.getFullYear();
  //获得上一个月的第一天
  var priorMonthFirstDay = getPriorMonthFirstDay(currentYear, currentMonth);
  return priorMonthFirstDay;
};

/***
 * 上月的最后一天时间
 */
export function getEndLastMonth() {
  //获取当前时间
  var currentDate = getCurrentDate();
  //获得当前月份0-11
  var currentMonth = currentDate.getMonth();
  //获得当前年份4位年
  var currentYear = currentDate.getFullYear();

  //当为12月的时候年份需要加1
  //月份需要更新为0 也就是下一年的第一个月
  if (currentMonth == 11) {
    currentYear++;
    currentMonth = 0; //就为
  } else {
    //否则只是月份增加,以便求的下一月的第一天
    currentMonth++;
  }

  //一天的毫秒数
  var millisecond = 1000 * 60 * 60 * 24;
  //求出上月的最后一天
  var lastDay = new Date(getBeginMonth().getTime() - millisecond);

  return endTime(lastDay);
};

//本年第一天时间
export function getYearFirstDay() {
  //获取当前时间
  var currentDate = getCurrentDate();
  //获得当前年份4位年
  var currentYear = currentDate.getFullYear();

  var time = currentYear + '/01/01 00:00:00'
  return time

}

/**
 * 返回上一个月的第一天Date类型
 * 
 **/
export function getPriorMonthFirstDay(year, month) {
  //年份为0代表,是本年的第一月,所以不能减
  if (month == 0) {
    month = 11; //月份为上年的最后月份
    year--; //年份减1
    return new Date(year, month, 1);
  }
  //否则,只减去月份
  month--;
  return new Date(year, month, 1);;
};

//本季度的开始时间
export function getquarterDay() {
  let now = new Date(); //当前日期
  let nowMonth = now.getMonth(); //当前月
  let nowYear = now.getFullYear(); //当前年
  let jd = Math.ceil((nowMonth + 1) / 3);
  let startTime = new Date(nowYear, (jd - 1) * 3, 1)
  return startTime
};
